import React, { useEffect, useRef } from "react";
import { gsap, Power2, Back, Linear } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { UseWindowSize } from "../helpers/UseWindowSize";

import LogoSVG from "./LogoSVG";

function LogoAnimation(props) {
    const animationRef = useRef(null);
    const windowSize = UseWindowSize();
    //  check if screen ratio is < 16:9
    const isTall = windowSize.height > windowSize.width * 0.5625;
    const tallFromat = isTall ? " tallFormatScreen" : "";

    const loopCheck = (timeline) => {
        console.log("loop check");
        if (animationRef) {
            props.setIsLoading(false);
        }
    };

    useEffect(() => {
        gsap.registerPlugin(DrawSVGPlugin);
        const tl = gsap
            .timeline({
                delay: 0.25,
                repeat: 0,
                paused: true,
                onComplete: () => {
                    loopCheck(tl);
                },
            })
            .set(".loading-animation-container", { display: "flex" })
            .from(".logo-line-1", {
                duration: 0.3,
                drawSVG: "0%",
                ease: "Linear.none",
            })
            .from(".logo-line-2", {
                duration: 0.1,
                drawSVG: "0%",
                ease: "Linear.none",
            })
            .from(".logo-line-3", {
                duration: 0.1,
                drawSVG: "100% 100%",
                ease: "Linear.none",
            })
            .from(".logo-line-4", {
                duration: 0.1,
                drawSVG: "0%",
                ease: "Linear.none",
            })
            .from(".logo-line-5", {
                duration: 0.1,
                drawSVG: "0%",
                ease: "Linear.none",
            })
            // .from(".logo-line-6",{ duration: 0.1, drawSVG: "0%", ease: "Linear.none"})
            .fromTo(
                ".outroLine",
                { display: "none", drawSVG: "0% 0%" },
                {
                    duration: 0.1,
                    display: "block",
                    drawSVG: "0% 2.5%",
                    ease: "Linear.none",
                }
            )
            .to(".logo-line-1", { duration: 0.3, drawSVG: "83.4% 100%", ease: Power2.easeOut }, "-=0.4")

            .from(".logo-speed-line-2", { duration: 0.1, drawSVG: "0%", ease: "Linear.none" }, 0.35)
            .to(".logo-speed-line-2", { duration: 0.1, drawSVG: "100% 100%", ease: Power2.easeOut }, 0.45)
            .from(".logo-speed-line-3", { duration: 0.1, drawSVG: "0%", ease: "Linear.none" }, 0.45)
            .to(".logo-speed-line-3", { duration: 0.1, drawSVG: "100% 100%", ease: Power2.easeOut }, 0.55)
            .from(".logo-speed-line-4", { duration: 0.1, drawSVG: "0%", ease: "Linear.none" }, 0.55)
            .to(".logo-speed-line-4", { duration: 0.1, drawSVG: "100% 100%", ease: Power2.easeOut }, 0.65)
            .from(".logo-speed-line-5", { duration: 0.1, drawSVG: "0%", ease: Linear.none }, 0.65)
            .to(".logo-speed-line-5", { duration: 0.1, drawSVG: "100% 100%", ease: Power2.easeOut }, 0.75)

            .from(".momatu-logo-letter-1", { duration: 0.4, y: 35, ease: Power2.easeOut }, 0.3)
            .from(".momatu-logo-letter-2", { duration: 0.4, y: 35, ease: Power2.easeOut }, 0.35)
            .from(".momatu-logo-letter-3", { duration: 0.4, y: 35, ease: Power2.easeOut }, 0.4)
            .from(".momatu-logo-letter-4", { duration: 0.4, y: 35, ease: Power2.easeOut }, 0.45)
            .from(".momatu-logo-letter-5", { duration: 0.4, y: 35, ease: Power2.easeOut }, 0.5)
            .from(".momatu-logo-letter-6", { duration: 0.4, y: 35, ease: Power2.easeOut }, 0.55)

            .addLabel("animate out")

            // animate out.
            .to(".logo-line-1", { duration: 0.4, drawSVG: "100% 100%", ease: Back.easeIn }, "+=0.4")
            .to(".logo-line-2", {
                duration: 0.1,
                drawSVG: "100% 100%",
                ease: "Linear.none",
            })
            .to(".logo-line-3", {
                duration: 0.1,
                drawSVG: "0%",
                ease: "Linear.none",
            })
            .to(".logo-line-4", {
                duration: 0.1,
                drawSVG: "100% 100%",
                ease: "Linear.none",
            })
            .to(".logo-line-5", {
                duration: 0.1,
                drawSVG: "100% 100%",
                ease: "Linear.none",
            })
            // .to(".logo-line-6",{ duration: 0.07, drawSVG: "100% 100%", ease: "Linear.none"})

            .to(".momatu-logo-letter-1", { duration: 0.4, y: -50, ease: Back.easeIn }, "-=0.5")
            .to(".momatu-logo-letter-2", { duration: 0.4, y: -50, ease: Back.easeIn }, "-=0.35")
            .to(".momatu-logo-letter-3", { duration: 0.4, y: -50, ease: Back.easeIn }, "-=0.35")
            .to(".momatu-logo-letter-4", { duration: 0.4, y: -50, ease: Back.easeIn }, "-=0.35")
            .to(".momatu-logo-letter-5", { duration: 0.4, y: -50, ease: Back.easeIn }, "-=0.35")
            .to(".momatu-logo-letter-6", { duration: 0.4, y: -50, ease: Back.easeIn }, "-=0.35")

            .to(".outroLine", { duration: 0.4, drawSVG: "0% 100%", ease: Power2.easeIn }, "-=0.8")
            .to(
                ".outroLine",
                {
                    duration: 0.5,
                    drawSVG: "100% 100%",
                    strokeWidth: "10px",
                    ease: Linear.none,
                },
                "-=0.25"
            )
            .from(".timeline-line-wrapper", { duration: 1, x: 1920, ease: Power2.easeInOut }, "-=0.75")
            .from(
                ".timeline-line",
                {
                    duration: 1,
                    strokeWidth: "20px",
                    ease: Power2.easeInOut,
                },
                "-=1"
            )
            .to(".logo-wrapper", { duration: 1, x: -1920, ease: Power2.easeInOut }, "-=1")
            .from(
                ".timeline-line",
                {
                    duration: 0.5,
                    // stroke: "#6260ab",
                    stroke: "#E75C3F",
                    ease: Power2.easeIn,
                },
                "-=0.5"
            );

        tl.play();
    }, [animationRef]);

    return (
        <div ref={animationRef} className={"svg-container loading-animation-container" + tallFromat}>
            <LogoSVG className="loading-animation" />
        </div>
    );
}

export default LogoAnimation;
